import React from 'react';
import { AuthDispatchContext } from '../context/auth-context';

export const useStartLogin = () => {
  const { asyncActions } = React.useContext(AuthDispatchContext);

  return (asyncActions?.startLogin || (async () => { return; }));
}